import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { LocationService } from './_services/location.service';
import { TranslateService } from 'ngx-translate-with-country';
import { Title, DOCUMENT } from '@angular/platform-browser';
// import * as $ from 'jquery';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';

  locations: any;
  ipAddress: any;
  country: any;
  ipForLocation: any;
  language: string;
  langCode: any;
  countryCode: any;
  countryLanguage: string;

  constructor(
    private route: ActivatedRoute,
    private locationService: LocationService,
    private router: Router,
    public translate: TranslateService,
    public titleService: Title,
    @Inject(DOCUMENT) private _document: any
  ) {
    router.events.subscribe(val => {
      // see also
      if (val instanceof NavigationEnd) {
        $('.submenu').removeClass('js-dropdown-active');
        window.scrollTo(0, 0);
      }
    });

    // this.translate.setDefaultLang('en', 'eu');
    this.country = this.locationService.country;
    this.language = this.locationService.langCode;
    this.translate.use(this.language, this.country);

    translate.onLangChange.map(x => x.lang)
      .subscribe(lang => this._document.documentElement.lang = lang);

    // this.eventProvider.currentLang.subscribe(lang => {
    //   this.translate.use(lang);
    // });
  }

  getLocations(): void {
    this.locationService.getLocations().subscribe(
      resultArray => {
        this.locations = resultArray;
      },
      error => console.log('Error ::' + error)
    );
  }

  getIpAddress() {
    this.locationService.getIpAddress();
  }

  ngOnInit() {
    setTimeout(() => {
      $(document).foundation();
    }, 1500);

    const pathname = window.location.pathname;
    const pathnameSplit = pathname.split('/');
    this.country = pathnameSplit[1];
    this.language = pathnameSplit[2];

    this.locationService.country = this.country;
    this.locationService.langCode = this.language;

    // this.translate.use(this.language);

    this.translate.onLangChange.map(x => x.lang)
      .subscribe(lang => this._document.documentElement.lang = lang);

    if (!this.country) {
      this.getIpAddress();
    } else {
      this.translate.use(this.locationService.langCode, this.locationService.country);
    }
  }
}
